export default {
  title: 'Nie przegap!',
  description: 'Włącz powiadomienia, aby być na bieżąco ze swoim zamówieniem.',
  buttons: {
    enable: 'Włącz',
  },
};
